import {ACTION_TYPES} from "../consts";
import {AnalyticsService} from "../../third-party-services/analytics/analytics-service";
import {PredictionShowEvent} from "../models/events/prediction-show-event";
import {AnalyticsEventHandler} from "../../infrastructure/handlers/analytics-event-handler";

export class PredictionShowEventHandler extends AnalyticsEventHandler {
  type = ACTION_TYPES.predictionShow;

  static injectables = [AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.eventType = PredictionShowEvent;
  }
}
